export class BreadcrumbPath {
    public Path: string;
    public FullPath: string;
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/breadcrumb/breadcrumb-path.ts